import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Multi-lingual support
import { t } from "i18next";

// Hooks
import { useLoader } from "../../../hooks/useLoaderContext/useLoaderContext";
import { useToaster } from "../../../hooks/useToasterContext/useToasterContext";

// API Manager
import { getApi } from "../../../services/apiManager/ApiManager";

// Types
import { EUserRoles } from "../../../components/shared/commonTypes/commonTypes";
import GlobalLoader from "../../../components/layout/GlobalLoader";

const VerifyUser: React.FC = () => {
  const { setLoading } = useLoader();
  const { setShowToaster } = useToaster();
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate an API call or user fetch logic
    const fetchUser = async () => {
      try {
        setLoading(true);
        const response = await getApi("/v1/user/current");

        // Ensure the loader is visible for at least 500ms
        const minLoaderTime = new Promise((resolve) =>
          setTimeout(resolve, 800),
        );
        if (response.status) {
          await minLoaderTime;
          if (
            response.data.roles[0].name === EUserRoles.admin ||
            response.data.roles[0].name === EUserRoles.manager ||
            response.data.roles[0].name === EUserRoles.agent
          ) {
            navigate("/admindashboard");
          } else if (response.data.roles[0].name === EUserRoles.superAdmin) {
            navigate("/masters");
          }
          // else if (response.data.roles[0].name === EUserRoles.agent) {
          //   navigate("/accessdenied");
          // }
        } else {
          localStorage.clear();
          navigate("/authenticate");
        }
      } catch (error) {
        setShowToaster(true, t("commonMessages.internalServerError"), "error");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <>
      <GlobalLoader />
    </>
  );
};

export default VerifyUser;
